<template>
    <div class="deelnemers">
        <p>Dit fonds heeft {{nmbDeelnemers | formatNumber }} deelnemers.
            Hieronder zie je de verhouding tussen actieve werknemers die premie betalen en pensioengerechtigden die een uitkering ontvangen.</p>

        <div class="deelnemers__chart" ref="chart"></div>
        <p class="comment"><sup>*</sup>  Voor een fonds zijn slapers degenen die niet meer actief deelnemen (premies betalen aan dit fonds) en de uitkeringsfase nog niet hebben bereikt.</p>
    </div>
</template>

<script>
    import Highcharts from 'highcharts';

    export default {
        name: "Deelnemers",
        props: {
            fonds: Object
        },
        watch: {
            fonds() {
                this.updateChart();
            }
        },
        computed: {
            nmbDeelnemers() {
                return this.fonds ? this.fonds.deelnemersTotaal : 0;
            }
        },
        mounted() {
            let series;
            if (this.fonds) {
                series = this.getSeries(this.fonds);
            } else {
                series = []
            }
            this.chart = Highcharts.chart(this.$refs.chart, {
                chart: {
                    plotBackgroundColor: null,
                    plotBorderWidth: null,
                    plotShadow: false,
                    type: 'pie'
                },
                title: {
                    text: ''
                },
                tooltip: {
                    pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        dataLabels: {
                            enabled: false
                        },
                        showInLegend: true
                    }
                },
                colors: ['#DC2222', '#74DC22', '#1E82FF'],
                series,
                credits: {
                    enabled: false
                }
            });
        },
        methods: {
            updateChart() {
                if (this.chart) {
                    const series = this.getSeries(this.fonds);
                    this.chart.update({series}, true, true);
                }
            },
            getSeries(fonds) {
                if (!fonds) return [];
                const data = [
                    { name: 'actieve werknemers', y: this.getPercentage(fonds.deelnemers, fonds.deelnemersTotaal) },
                    { name: 'slapers*', y: this.getPercentage(fonds.gewezenDeelnemers, fonds.deelnemersTotaal) },
                    { name: 'pensioengerechtigden', y: this.getPercentage(fonds.pensioengerechtigden, fonds.deelnemersTotaal) }
                ];
                return [{
                    colorByPoint: true,
                    data
                }]
            },
            getPercentage(part, total) {
                return Math.round(part * 100 / total);
            }
        }
    }
</script>

<style scoped>

</style>